// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__Bq_fs","greenBtn":"styles_greenBtn__22_2u","title":"styles_title__2ywg9","borderWrap":"styles_borderWrap__yxluJ","text":"styles_text__2gnzo"};